import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { DeleteTeamInput, DeleteTeamOutput, WebAppRoutes } from "types/web-app";

export const deletePokeTeam = async (
  accessToken: string,
  input: DeleteTeamInput,
) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.DELETE_POKE_TEAM,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    return (await response.json()) as ServiceResponse<DeleteTeamOutput>;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
